import React, { useEffect, useState } from "react";
import SubscriptionRequired from "../../components/SubscriptionRequired";

const SubscriptionRequiredPage: React.FC = () => {
  const [errorData, setErrorData] = useState<any>(null);

  useEffect(() => {
    // Get error data from session storage
    const storedError = sessionStorage.getItem("subscriptionError");
    if (storedError) {
      try {
        setErrorData(JSON.parse(storedError));
      } catch (error) {
        console.error("Error parsing subscription error:", error);
      }
    }
  }, []);

  return (
    <SubscriptionRequired
      message={errorData?.message}
      isAdmin={errorData?.isAdmin}
    />
  );
};

export default SubscriptionRequiredPage;

